export const tableColumns = {
  report_library: [
    {
      title: '编码',
      field: 'code',
      width: 100,
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '审核状态',
      field: 'isApproved',
      width: 100,
      slots: {
        default: ({ row }, h) => {
          return [
            <span>{ row.isApproved === 0 ? '未审核' : '已审核' }</span>
          ]
        }
      }
    }
  ],
  cashflow_item: [
    {
      title: '编码',
      field: 'code',
      minWidth: '60px',
      tooltip: true
    }, {
      title: '名称',
      field: 'name',
      minWidth: '90px',
      tooltip: true
    }
  ],
  report_item: [
    {
      title: '编码',
      field: 'code',
      minWidth: '60px'
    },
    {
      title: '名称',
      field: 'name',
      minWidth: '90px'
    },
    {
      title: '审核状态',
      field: 'typeCode',
      minWidth: '100px'
    }
  ],
  company: [
    { title: '编码', field: 'code', align: 'center', tooltip: true },
    { title: '名称', field: 'name', align: 'center', tooltip: true },
    { title: '形态', field: 'companyFormName', align: 'center', tooltip: true }
  ],
  changecompany: [{
    title: '编码',
    field: 'code',
    align: 'center',
    tooltip: true
  },
  {
    title: '名称',
    field: 'name',
    align: 'center',
    tooltip: true
  },
  {
    title: '形态',
    field: 'companyFormName',
    align: 'center',
    tooltip: true
  }
  ],
  department: [{
    title: '编码',
    field: 'code',
    align: 'center',
    tooltip: true
  },
  {
    title: '名称',
    field: 'name',
    align: 'center',
    tooltip: true
  },
  {
    title: '属性',
    field: 'deptTypeName',
    tooltip: true
  },
  {
    title: '数据状态',
    field: 'isEnableStr',
    width: 160,
    tooltip: true
  },
  {
    title: '使用公司',
    field: 'useCompanyName',
    tooltip: true
  }],
  wd_dept: [{
    title: '部门编码',
    field: 'code',
    align: 'center',
    tooltip: true
  },
  {
    title: '名称',
    field: 'name',
    align: 'center',
    tooltip: true
  },
  {
    title: '属性',
    field: 'deptTypeName',
    tooltip: true
  },
  {
    title: '上级部门',
    field: 'deptTypeName',
    tooltip: true
  },
  {
    title: '使用公司',
    field: 'useCompanyName',
    tooltip: true
  },
  {
    title: '使用公司业务单元',
    field: 'businessUnitName',
    tooltip: true
  },
  {
    title: '数据状态',
    tooltip: true,
    field: 'isEnable',
    slots: {
      default: ({ row }, h) => {
        return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
      }
    }
  }],
  dept: [{
    title: '编码',
    field: 'code',
    align: 'center',
    tooltip: true
  },
  {
    title: '名称',
    field: 'name',
    align: 'center',
    tooltip: true
  },
  {
    title: '属性',
    field: 'deptTypeName',
    tooltip: true
  },
  {
    title: '上级部门',
    field: 'prarentName',
    tooltip: true
  },
  {
    title: '数据状态',
    field: 'isEnableStr',
    tooltip: true
  },
  {
    title: '使用公司',
    field: 'useCompanyName',
    tooltip: true
  },
  {
    title: '使用公司业务单元',
    field: 'businessUnitName',
    tooltip: true
  }
  ],
  personInChargeName: [{
    title: '员工编码',
    field: 'code',
    align: 'center',
    tooltip: true
  },
  {
    title: '员工姓名',
    field: 'name',
    align: 'center',
    tooltip: true
  },
  {
    title: '手机号',
    field: 'contactNumber',
    align: 'center',
    tooltip: true
  },
  {
    title: '部门',
    field: 'dept',
    align: 'center',
    tooltip: true
  },
  {
    title: '使用公司',
    field: 'userCompany',
    align: 'center',
    tooltip: true
  },
  {
    title: '数据状态',
    tooltip: true,
    field: 'isEnable',
    slots: {
      default: ({ row }, h) => {
        return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
      }
    }
  }
  ],
  auxiliary: [
    { title: '编码', field: 'entityCode', align: 'center', tooltip: true },
    { title: '名称', field: 'entityName', align: 'center', tooltip: true },
    { title: '核算账簿', field: 'accountBookName', align: 'center', tooltip: true }
  ],
  wd_bank_account: [
    { title: '银行账号', field: 'code', align: 'center', tooltip: true },
    { title: '账号名称', field: 'name', align: 'center', tooltip: true },
    { title: '开户银行', field: 'branchBankName', align: 'center', tooltip: true }
    // { title: '公司', field: 'useCompanyName', align: 'center', tooltip: true }
  ],
  attrBusiness: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '形态',
      field: 'unitFormName',
      tooltip: true
    },
    {
      title: '数据状态',
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [
            <div>
              <span style={{ display: 'inline-block', width: '5px', height: '5px', backgroundColor: row.isEnable === 0 ? '#F73E3E' : '#595959', borderRadius: '50%', marginRight: '10px' }}></span>
              <span style={{
                verticalAlign: 'middle'
              }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>
            </div>
          ]
        }
      }
    }
  ],
  depttype: [{
    title: '编码',
    field: 'code',
    align: 'center',
    tooltip: true
  },
  {
    title: '名称',
    field: 'name',
    align: 'center',
    tooltip: true
  }],
  period: [
    {
      title: '编码',
      field: 'code'
    },
    {
      title: '名称',
      field: 'name'
    }
  ],
  accountBook: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '会计准则',
      field: 'standardName',
      tooltip: true
    },
    {
      title: '记账本位币',
      field: 'accountingCurrencyName',
      tooltip: true
    }
  ],
  accountBookSetting: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '会计准则',
      field: 'accountingStandardName',
      tooltip: true
    },
    {
      title: '记账本位币',
      field: 'accountingCurrencyName',
      tooltip: true
    }
  ],
  abstract: [
    {
      title: '摘要内容',
      field: 'abstractContent',
      tooltip: true
    },
    // {
    //   title: '公司',
    //   field: 'createEnterpriseName',
    //   tooltip: true
    // },
    {
      title: '助记码',
      field: 'abstractCode',
      tooltip: true
    }
  ],
  subject: [
    {
      title: '科目编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '科目名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '会计要素',
      field: 'accountElementItemName',
      tooltip: true
    },
    {
      title: '科目类别',
      field: 'subjectCategoryName',
      tooltip: true
    },
    {
      title: '余额方向',
      field: 'balanceDirection',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span className="readonly">{row.balanceDirection ? '贷' : '借'}</span>]
        }
      }
    },
    // {
    //   title: '发生额方向',
    //   field: 'companyFormName',
    //   tooltip: true
    // },
    {
      title: '分类',
      field: 'accountCategory',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span
            className="readonly">{row.accountCategory === 'B01' ? '一般科目' : row.accountCategory === 'A01' ? '现金科目' : row.accountCategory === 'A02' ? '银行科目' : '现金等价物'}</span>]
        }
      }
    },
    {
      title: '辅助核算',
      field: 'auxiliaryNames',
      tooltip: true
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  subjectSetting: [
    {
      title: '科目编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '科目名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '会计要素',
      field: 'accountElementItemName',
      tooltip: true
    },
    {
      title: '科目类别',
      field: 'subjectCategoryName',
      tooltip: true
    },
    {
      title: '余额方向',
      field: 'balanceDirection',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span>{ row.balanceDirection ? '贷' : '借' }</span>]
        }
      }
    },
    {
      title: '分类',
      field: 'accountCategory',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span class="readonly">{ row.accountCategory === 'B01' ? '一般科目' : row.accountCategory === 'A01' ? '现金科目' : row.accountCategory === 'A02' ? '银行科目' : '现金等价物'}</span>]
        }
      }
    },
    {
      title: '辅助核算',
      field: 'auxiliaryNames',
      tooltip: true
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  projectCode: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    }
  ],
  employee: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '公司',
      field: 'company',
      minWidth: 60,
      tooltip: true
    },
    {
      title: '部门',
      field: 'companyFormName',
      tooltip: true
    },
    {
      title: '手机号码',
      field: 'companyFormName',
      tooltip: true
    },
    {
      title: '电子邮箱',
      field: 'companyFormName',
      tooltip: true
    }
  ],
  wd_staff: [
    {
      title: '员工编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '员工姓名',
      field: 'name',
      tooltip: true
    },
    {
      title: '手机号码',
      field: 'mobile',
      tooltip: true
    },
    {
      title: '成本中心',
      field: 'costCenter',
      tooltip: true
    },
    // {
    //   title: '使用公司',
    //   field: 'useCompanyName',
    //   tooltip: true
    // },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  wd_account_book_entity: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '核算账簿',
      field: 'accountBookName',
      tooltip: true
    }
  ],
  checkAccounting: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'entityName',
      tooltip: true
    },
    {
      title: '核算账簿',
      field: 'accountBookName',
      tooltip: true
    }
  ],
  checkSynergyAccounting: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '核算账簿',
      field: 'accountBookName',
      tooltip: true
    }
  ],
  classify: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '数据状态',
      field: 'isEnable',
      tooltip: true
    }
  ],
  generalLedger: [ // 总账账簿（查询条件）
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '会计准则',
      field: 'accountingStandardName',
      tooltip: true
    },
    {
      title: '记账本位币',
      field: 'accountingCurrencyName',
      tooltip: true
    }
  ],
  auxiliarySeting: [
    {
      title: '编码',
      field: 'code',
      minWidth: 100,
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      minWidth: 100,
      tooltip: true
    },
    {
      title: '数据状态',
      field: 'isEnable',
      minWidth: 100,
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  cashflow: [ // 现金流量项目
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '方向',
      field: 'cashFlowDirection',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span
            className="readonly">{row.cashFlowDirection ? '现金流入' : row.cashFlowDirection === 0 ? '现金流出' : ''}</span>]
        }
      }
    },
    // {
    //   title: '分组',
    //   field: 'name',
    //   tooltip: true
    // },
    {
      title: '数据状态',
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  wd_customer: [
    {
      title: '客户编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '客户名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '客户类型',
      field: 'customerType',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span>{ row.customerType ? '个人' : '企业' }</span>]
        }
      }
    },
    {
      title: '内部客户',
      field: 'isInternalCustomer',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span>{ row.isInternalCustomer ? '是' : '否' }</span>]
        }
      }
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  wd_supplier: [
    {
      title: '供应商编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '供应商名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '供应商类型',
      field: 'supplierType',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span>{ row.supplierType ? '个人' : '企业' }</span>]
        }
      }
    },
    {
      title: '内部供应商',
      field: 'isInternalSupplier',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span>{ row.isInternalSupplier ? '是' : '否' }</span>]
        }
      }
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  wd_project: [
    {
      title: '项目编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '项目名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  parentdept: [
    {
      title: '编码',
      field: 'code',
      align: 'center',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      align: 'center',
      tooltip: true
    },
    {
      title: '属性',
      field: 'deptTypeName',
      tooltip: true
    },
    {
      title: '数据状态',
      field: 'isEnableStr',
      tooltip: true
    },
    {
      title: '使用公司',
      field: 'useCompanyName',
      tooltip: true
    }
  ],
  multiColumn: [
    {
      title: '编码',
      field: 'code',
      align: 'center',
      tooltip: true
    },
    {
      title: '名称',
      field: 'schemeName',
      align: 'center',
      tooltip: true
    },
    {
      title: '类型',
      field: 'schemeTypeName',
      align: 'center',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span>{ row.schemeType === 0 ? '科目多栏账' : '辅助核算多栏账' }</span>]
        }
      }
    }
  ],
  wd_accounting_item_value: [
    {
      title: '编码',
      field: 'code',
      align: 'center',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      align: 'center',
      tooltip: true
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  bank: [
    { title: '编码', field: 'code', align: 'center', tooltip: true },
    { title: '名称', field: 'name', align: 'center', tooltip: true },
    { title: '银行类别', field: 'bankCategoryName', align: 'center', tooltip: true }
  ],
  assist_all: [
    {
      title: '编码',
      field: 'code',
      align: 'center',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      align: 'center',
      tooltip: true
    }
  ],
  wd_cost_item: [
    {
      title: '项目编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '项目名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '数据状态',
      tooltip: true,
      field: 'isEnable',
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  wd_cost_center: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '功能范围',
      field: 'funcRange',
      tooltip: true
    },
    {
      title: '归属公司',
      field: 'companyName',
      tooltip: true
    },
    {
      title: '数据状态',
      field: 'dataStatus',
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [<span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>]
        }
      }
    }
  ],
  userMobile: [
    {
      title: '用户手机号码',
      field: 'mobile',
      tooltip: true,
      minWidth: 100
    },
    {
      title: '用户姓名',
      field: 'name',
      tooltip: true,
      minWidth: 100
    },
    {
      title: '数据状态',
      field: 'isEnable',
      tooltip: true,
      minWidth: 60,
      slots: {
        default: ({ row }, h) => {
          return [
            <div>
              <span style={{ display: 'inline-block', width: '5px', height: '5px', backgroundColor: row.isEnable === 0 ? '#F73E3E' : '#595959', borderRadius: '50%', marginRight: '10px' }}></span>
              <span style={{ verticalAlign: 'middle' }}>{ row.isEnable === 0 ? '已失效' : '已生效' }</span>
            </div>
          ]
        }
      }
    }
  ],
  baseAccountantSubject: [
    {
      title: '会计科目表编码',
      field: 'code',
      align: 'left',
      tooltip: true
    },
    {
      title: '会计科目表名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '会计准则',
      field: 'accStandardName',
      tooltip: true
    },
    {
      title: '会计要素表',
      field: 'elementName',
      tooltip: true
    }
  ],
  baseCashflow: [
    {
      title: '科目编码',
      field: 'code',
      align: 'center',
      tooltip: true
    },
    {
      title: '科目名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '账簿类型名称',
      field: 'accountBookTypeName',
      tooltip: true
    },
    {
      title: '会计准则名称',
      field: 'accStandardName',
      tooltip: true
    }
  ],
  accountBooks: [ // 总账账簿(查询条件)
    {
      title: '编码',
      field: 'code',
      tooltip: true,
      minWidth: '90px'
    }, {
      title: '名称',
      field: 'name',
      tooltip: true,
      minWidth: '90px'
    }, {
      title: '会计准则',
      field: 'standardName',
      tooltip: true,
      minWidth: '100px'
    }, {
      title: '记账本位币',
      field: 'accountingCurrencyName',
      tooltip: true,
      minWidth: '100px'
    }
  ],
  // 成本中心
  costCenter: [{
    title: '编码',
    field: 'code',
    tooltip: true
  },
  {
    title: '名称',
    field: 'name',
    tooltip: true
  },
  {
    title: '功能范围',
    field: 'funcRange',
    tooltip: true
  },
  {
    title: '归属公司',
    field: 'companyName',
    tooltip: true
  }],
  // 员工 选择公司
  employee_company: [
    { title: '编码', field: 'code', tooltip: true },
    { title: '名称', field: 'name', tooltip: true },
    { title: '简称', field: 'companyFormName', tooltip: true },
    { title: '纳税人性质', field: 'companyFormName', tooltip: true }
  ],
  // 统一门户 员工 选择公司
  portal_employee_company: [
    { title: '编码', field: 'code', tooltip: true },
    { title: '名称', field: 'name', tooltip: true },
    { title: '形态', field: 'companyForm', tooltip: true }
    // { title: '简称', field: 'companyFormName', tooltip: true },
    // { title: '纳税人性质', field: 'companyFormName', tooltip: true }
  ],
  // 会计准则
  account_standards: [
    {
      title: '编码',
      field: 'code',
      minWidth: '60px',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      minWidth: '90px',
      tooltip: true
    },
    {
      title: '国家地区',
      field: 'area',
      minWidth: '120px',
      tooltip: true
    },
    {
      title: '税收制度',
      field: 'taxSystemName',
      minWidth: '90px'
    }
  ],
  account_standards_Currency: [
    {
      title: '编码',
      field: 'code',
      minWidth: '60px',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      minWidth: '60px',
      tooltip: true
    },
    {
      title: 'ISO货币代码',
      field: 'isoCode',
      minWidth: '60px',
      tooltip: true
    },
    {
      title: '货币符号',
      field: 'symbol',
      minWidth: '60px',
      tooltip: true
    }
  ],
  // 财务系统查询公司
  finance_company: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    },
    {
      title: '形态',
      field: 'companyForm',
      tooltip: true
    }
  ],
  // 税种
  wd_tax_category: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    }
  ],
  // 税种
  wd_settlement_method: [
    {
      title: '编码',
      field: 'code',
      tooltip: true
    },
    {
      title: '名称',
      field: 'name',
      tooltip: true
    }
  ]
}
export const names = {
  changecompany: '部门变更公司',
  department: '部门', //
  accountBookSetting: '核算账簿', // -多栏账方案
  subjectSetting: '会计科目', // -参数设置/多栏账方案
  projectCode: '项目编码', // -多栏账方案
  auxiliarySeting: '辅助核算项', // 用于多栏账方案栏目编码
  employee: '员工', // 员工
  userMobile: '用户手机号码', // 用户手机号码
  baseAccountantSubject: '会计科目基准表', // 会计科目基准表
  baseCashflow: '现金流量项目表', // 现金流量项目表
  accountBooks: '账簿', // 总账账簿(查询条件)
  costCenter: '成本中心', // 员工 选择成本中心
  employee_company: '员工公司', // 员工公司
  account_standards: '会计准则', // 会计准则
  account_standards_Currency: '会计准则本位币', // 获取会计准则本位币
  portal_employee_company: '',
  finance_company: '/finsaas-gls/company/findCompanyPageByUcs',
  assist_all: '辅助核算', // 辅助核算的接口
  company: '公司',
  dept: '部门', // 部门
  wd_dept: '部门', // 部门
  personInChargeName: '负责人', // 负责人
  auxiliary: '银行账户', // 银行账户
  wd_bank_account: ' 银行账户', // 银行账户
  bank: ' 银行账户', // 银行账户
  attrBusiness: '业务单元', // 业务单元
  depttype: '属性', // 属性
  period: ' 期初余额', // 期初余额
  accountBook: '核算账簿', // 核算账簿
  abstract: '常用摘要', // 常用摘要
  subject: '会计科目', // 会计科目
  wd_staff: '员工', // 员工
  wd_project: '自定义辅助核算项目', // 自定义辅助核算-项目
  wd_account_book_entity: '核算主体', // 辅助核算项-核算主体
  checkAccounting: '核算主体', // 总账-核算主体
  checkSynergyAccounting: '核算主体', // 总账-核算主体
  classify: '分类', // 分类
  cashflow: '现金流量', // 现金流量
  wd_customer: '客户', // 客户
  wd_supplier: '供应商', // 供应商
  wd_accounting_item_value: '自定义辅助核算', // 自定义辅助核算
  parentdept: '上级部门', // 上级部门
  multiColumn: '多栏账方案', // 多栏账方案
  wd_cost_item: '自定义辅助核算', // 自定义辅助核算-项目
  wd_cost_center: '成本中心', // 成本中心
  report_item: '报表项目', // 报表项目-报表类型 待处理
  cashflow_item: '现金流量项目', // 现金流量项目 待处理
  report_library: '报表项目库', // 报表项目库
  wd_tax_category: '税种', // 税种
  wd_settlement_method: '结算方式' // 结算方式
}
export const urls = {
  changecompany: '/finsaas-gls/company/findCompanyPageOut', // 部门变更公司
  department: '/finsaas-gls/dept/findDeptPage', // 部门
  accountBookSetting: '/finsaas-gls//accountBook/findAccountBookPage', // 核算账簿-多栏账方案
  subjectSetting: '/finsaas-gls/accountSubject/findPage', // 会计科目-参数设置/多栏账方案
  projectCode: '/finsaas-gls/accountSubject/findAllChildInfo', // 项目编码-多栏账方案
  auxiliarySeting: '/finsaas-gls/accountSubject/findSourceTableList', // 辅助核算项 - 用于多栏账方案栏目编码
  employee: '/finsaas-gls/dept/findDeptPage', // 员工
  userMobile: '/finsaas-gls/sysUser/findNotImportPageFromUcs', // 用户手机号码
  baseAccountantSubject: '/finsaas-gls/accountSubject/findSubjectSelection', // 会计科目基准表
  baseCashflow: '/finsaas-gls/cashFlowItem/findCashFlowItemSelection', // 现金流量项目表
  accountBooks: '/finsaas-gls/accountBook/findAccountBookPage', // 总账账簿(查询条件)
  costCenter: '/ucs-org/cost-center/query-in-page', // 员工 选择成本中心
  employee_company: '/finsaas-gls/company/findCompanyPage', // 员工 选择公司
  account_standards: '/finsaas-gls/accounting-standard/query', // 会计准则
  account_standards_Currency: '/finsaas-gls/accounting-standard/currencies', // 获取会计准则本位币
  portal_employee_company: '/ucs-org/company/query-company-in-page',
  finance_company: '/finsaas-gls/company/findCompanyPageByUcs',
  assist_all: '/finsaas-gls/accountSubject/findSourceTableList', // 辅助核算的接口
  company: '/ucs-org/company/query-company-in-page',
  dept: '/finsaas-gls/dept/findDeptPage', // 部门
  wd_dept: '/finsaas-gls/accountSubject/findSourceTableList', // 部门
  personInChargeName: '/finsaas-gls/staff/findStaffPage', // 负责人
  auxiliary: '/finsaas-gls/bankAccount/findAccountBookEntityList', // 银行账户
  wd_bank_account: '/finsaas-gls/accountSubject/findSourceTableList', // 银行账户
  bank: '/finsaas-gls/bankAccount/findBankPage', // 银行账户
  attrBusiness: '/finsaas-gls/businessUnit/findBusinessUnitPage', // 业务单元
  depttype: '/finsaas-gls/dept/findDeptTypePage', // 属性
  period: '/ledger/balanceSubjectInit/findUserAccountBookPage', // 期初余额
  accountBook: '/finsaas-gls/accountBook/findAccountBookPage', // 核算账簿
  abstract: '/finsaas-gls/commonAbstract/findCommonAbstractPage', // 常用摘要
  subject: '/finsaas-gls/accountSubject/findPage', // 会计科目
  wd_staff: '/finsaas-gls/accountSubject/findSourceTableList', // 员工
  wd_project: '/finsaas-gls/accountSubject/findSourceTableList', // 自定义辅助核算-项目
  wd_account_book_entity: '/finsaas-gls/accountSubject/findSourceTableList', // 辅助核算项-核算主体
  checkAccounting: '/finsaas-gls/accountBookEntity/findAccountBookEntityPageByAccBookIdList', // 总账-核算主体
  checkSynergyAccounting: '/finsaas-gls/accountBookEntity/findAccountBookEntityPageByAccBookIdList', // 总账-核算主体
  classify: '/finsaas-gls/dept/findDeptPage', // 分类
  cashflow: '/finsaas-gls/cashFlowItem/findCashFlowItemByPage', // 现金流量
  wd_customer: '/finsaas-gls/accountSubject/findSourceTableList', // 客户
  wd_supplier: '/finsaas-gls/accountSubject/findSourceTableList', // 供应商
  wd_accounting_item_value: '/finsaas-gls/accountSubject/findSourceTableList', // 自定义辅助核算
  parentdept: '/finsaas-gls/dept/findParentDeptList', // 上级部门
  multiColumn: '/ledger/multiColumnScheme/findMultiColumnSchemePage', // 多栏账方案
  wd_cost_item: '/finsaas-gls/accountSubject/findSourceTableList', // 自定义辅助核算-项目
  wd_cost_center: '/finsaas-gls/accountSubject/findSourceTableList', // 成本中心
  report_item: '/finsaas-gls/financialReportType/findFinancialReportTypePage', // 报表项目-报表类型 待处理
  cashflow_item: '/finsaas-gls/cashFlowItem/findCashFlowItemByPage', // 现金流量项目 待处理
  report_library: '/finsaas-gls/financialReportItemSet/findReportItemListPage', // 报表项目库
  wd_tax_category: '/finsaas-gls/accountSubject/findSourceTableList', // 税种
  wd_settlement_method: '/finsaas-gls/accountSubject/findSourceTableList' // 结算方式
}

export const fields = {
  subjectSetting: ['code', 'name'],
  account_standards: ['code', 'name'],
  account_standards_Currency: ['code', 'name'],
  costCenter: ['code', 'name'],
  multiColumn: ['code', 'schemeName'],
  abstract: ['code', 'abstractContent'],
  checkAccounting: ['code', 'entityName'],
  checkSynergyAccounting: ['code', 'name']
}
